/**
 * The standard answers for the repeating columns of a prescription.
 *
 * These are suggestions, not a closed list. The problem being solved is that
 * every prescription read differently because everyone typed their own wording
 * — "aft food", "After Food", "a/f" — which makes the register unreadable and
 * unsearchable. Offering the standard answer one tap away fixes that in
 * practice, without ever refusing a clinician who needs something unusual.
 */

/** Morning-afternoon-night, the notation the clinic already writes. */
export const FREQUENCIES = [
  '1-0-0',
  '0-1-0',
  '0-0-1',
  '1-0-1',
  '1-1-1',
  '1-1-1-1',
  '0-0-0-1',
  'SOS',
  'STAT',
  'Once weekly',
]

export const DURATIONS = [
  '3 days',
  '5 days',
  '7 days',
  '10 days',
  '15 days',
  '1 month',
  '2 months',
  '3 months',
  'Continuous',
]

/** Before food, after food, or nothing to say — an injection has no "food". */
export const INSTRUCTIONS = ['Before food', 'After food', 'Nil']

/** The tests this clinic orders most. Free text still works for the rest. */
export const TEST_NAMES = [
  'CBC',
  'ESR',
  'CRP',
  'Blood Sugar (F)',
  'Blood Sugar (PP)',
  'HbA1c',
  'Hb',
  'Lipid Profile',
  'LFT',
  'RFT',
  'TSH',
  'Urine Routine',
  'X-ray',
  'ECG',
  'Ultrasound',
]
